var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResultPaymentGateway({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ion:card-sharp"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1 13.5C1 13.6326 1.05268 13.7598 1.14645 13.8536C1.24021 13.9473 1.36739 14 1.5 14H14.5C14.6326 14 14.7598 13.9473 14.8536 13.8536C14.9473 13.7598 15 13.6326 15 13.5V7.4375H1V13.5ZM3.0625 9.1875C3.0625 9.1212 3.08884 9.05761 3.13572 9.01072C3.18261 8.96384 3.2462 8.9375 3.3125 8.9375H6.1875C6.2538 8.9375 6.31739 8.96384 6.36428 9.01072C6.41116 9.05761 6.4375 9.1212 6.4375 9.1875V11.1875C6.4375 11.2538 6.41116 11.3174 6.36428 11.3643C6.31739 11.4112 6.2538 11.4375 6.1875 11.4375H3.3125C3.2462 11.4375 3.18261 11.4112 3.13572 11.3643C3.08884 11.3174 3.0625 11.2538 3.0625 11.1875V9.1875ZM14.5 3H1.5C1.36739 3 1.24021 3.05268 1.14645 3.14645C1.05268 3.24021 1 3.36739 1 3.5V5.5625H15V3.5C15 3.36739 14.9473 3.24021 14.8536 3.14645C14.7598 3.05268 14.6326 3 14.5 3Z",
    fill: "#292D32"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResultPaymentGateway);
export default __webpack_public_path__ + "static/media/result_payment_gateway.cec77a9a492a16ce3d2873220076ad96.svg";
export { ForwardRef as ReactComponent };